var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45 3.912c1.649-1.826 4.3-1.8 6.017-.018l.01.011.523.588.517-.581c1.637-1.813 4.385-1.816 6.025-.009 1.621 1.693 1.597 4.547.011 6.307a206.56 206.56 0 0 1-3.002 3.303l-.003.003a204.941 204.941 0 0 0-2.986 3.286l-.554.628-6.55-7.208c-1.622-1.694-1.597-4.55-.008-6.31Z",
    fill: "currentColor"
  })));
};
export default SvgHeartFilled;